import { apiClient } from "@api/apiClient";

import { GetInitEntryDataResponse } from "./initEntryData.interface";

const API_ENDPOINT = {
  get: "/des/article-entry-data/init-data",
};

export const initEntryDataApis = {
  get: async (id: string) => {
    const { data } = await apiClient.get<GetInitEntryDataResponse>(
      `${API_ENDPOINT.get}?id=${id}`,
    );

    return data.data;
  },
};
